var map = {
	"./da-DK.json": 13940,
	"./dan.json": 36944,
	"./de-DE.json": 94478,
	"./dut.json": 36070,
	"./en-US.json": 65847,
	"./es-419.json": 43818,
	"./es-ES.json": 3960,
	"./fi-FI.json": 72570,
	"./fin.json": 69350,
	"./fr-FR.json": 25348,
	"./fre.json": 89324,
	"./ger.json": 13405,
	"./id-ID.json": 89886,
	"./ind.json": 71666,
	"./it-IT.json": 6238,
	"./ita.json": 67491,
	"./ja-JP.json": 57853,
	"./jpn.json": 60875,
	"./ko-KR.json": 10799,
	"./kor.json": 73951,
	"./nl-NL.json": 65372,
	"./por-BR.json": 98917,
	"./pt-BR.json": 40440,
	"./ro-RO.json": 89678,
	"./ru-RU.json": 81914,
	"./rum.json": 40119,
	"./rus.json": 7805,
	"./spa-ES.json": 92004,
	"./tr-TR.json": 19832,
	"./tur.json": 55144,
	"./vi-VN.json": 1623,
	"./vie.json": 57727,
	"./zh-CN.json": 45851,
	"./zho-CN.json": 60794
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22412;